/* ============================================================================
   ANIMOCO V4. Comportements de la fiche produit.

   Aucune librairie. Le défilement de la galerie et des carrousels repose sur
   scroll-snap natif : le script ne fait que synchroniser l'état visible.
   L'ajout au panier, le panier et le paiement restent gérés par les composants
   natifs d'Horizon. Aucun texte n'existe uniquement ici.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduce) document.documentElement.classList.add('v4-js');

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  /* ------------------------------------------------------ 1. Galerie produit */
  function initGallery(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var track = root.querySelector('[data-v4-track]');
    if (!track) return;

    var slides = root.querySelectorAll('[data-v4-slide]');
    var thumbs = root.querySelectorAll('[data-v4-thumb]');
    var dots = root.querySelectorAll('[data-v4-dot]');
    var current = root.querySelector('[data-v4-current]');
    var prev = root.querySelector('[data-v4-prev]');
    var next = root.querySelector('[data-v4-next]');
    var index = 0;

    function go(i) {
      var target = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    function paint(i) {
      index = i;
      each(thumbs, function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      each(dots, function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (current) current.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      /* Une vidéo qui sort de l'écran ne doit pas continuer à jouer. */
      each(slides, function (s, n) {
        if (n === i) return;
        var v = s.querySelector('video');
        if (v && !v.paused) v.pause();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio > 0.55) {
              paint(Array.prototype.indexOf.call(slides, e.target));
            }
          });
        },
        { root: track, threshold: [0.6] }
      );
      each(slides, function (s) {
        io.observe(s);
      });
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    each(thumbs, function (t, n) {
      t.addEventListener('click', function () { go(n); });
    });
    each(dots, function (d, n) {
      d.addEventListener('click', function () { go(n); });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    paint(0);
  }

  /* ---------------------------------------------------------- Analytics
     Un seul point d'entrée. Les évènements partent vers dataLayer, vers la
     couche analytique de Shopify si elle est présente, et vers un évènement
     DOM que n'importe quel outil peut écouter. Aucune donnée personnelle. */
  function track(name, payload) {
    var data = payload || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
    } catch (e) { /* dataLayer indisponible */ }
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics indisponible */ }
    try {
      document.dispatchEvent(new CustomEvent('animoco:' + name, { detail: data }));
    } catch (e) { /* CustomEvent indisponible */ }
  }

  /* ------------------------------------------- 2. Choix de l'offre et prix
     Le choix pilote le champ de variante, le prix affiché partout, le libellé
     de la barre persistante et le lien Amazon correspondant. */
  function initOffers(root) {
    if (!root || root.dataset.offersReady === 'true') return;

    var variantInput = root.querySelector('input[name="id"]');
    var inputs = root.querySelectorAll('[data-v4-offer]');
    if (!inputs.length) return;

    function apply(input) {
      if (!input) return;
      if (variantInput && input.dataset.variantId) variantInput.value = input.dataset.variantId;
      each(document.querySelectorAll('[data-v4-price]'), function (n) { n.textContent = input.dataset.price || ''; });
      each(document.querySelectorAll('[data-v4-offer-label]'), function (n) { n.textContent = input.dataset.label || ''; });
      each(document.querySelectorAll('[data-v4-amazon]'), function (a) {
        var url = input.dataset.amazon || a.dataset.fallback || '';
        if (url) {
          a.href = url;
          a.hidden = false;
        } else {
          a.hidden = true;
        }
      });
      root.dataset.currentVariant = input.dataset.variantId || '';
      root.dataset.currentLabel = input.dataset.label || '';
      root.dataset.currentPrice = input.dataset.priceRaw || '';
    }

    each(inputs, function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        apply(input);
        track('offer_selected', {
          variant_id: input.dataset.variantId,
          offer: input.dataset.label,
          value: Number(input.dataset.priceRaw || 0)
        });
      });
      if (input.checked) apply(input);
    });

    root.dataset.offersReady = 'true';
  }

  /* --------------------------------- 2 bis. Commander maintenant
     Le bouton ne remplit pas un panier visible : il prépare la commande et
     envoie directement au paiement Shopify. Le panier est vidé avant l'ajout
     pour que le paiement contienne exactement l'offre choisie, comme le fait
     le bouton d'achat rapide natif.

     Sans JavaScript, le formulaire reste un vrai formulaire Shopify avec
     return_to vers le paiement : le parcours fonctionne quand même. */
  function initCheckout(root) {
    if (!root || root.dataset.checkoutReady === 'true') return;
    var form = root.querySelector('form[data-v4-form]');
    var button = root.querySelector('[data-v4-submit]');
    if (!form || !button) return;
    root.dataset.checkoutReady = 'true';

    var busy = false;

    function go(source) {
      if (busy) return;
      busy = true;
      button.classList.add('is-busy');

      var variantInput = form.querySelector('input[name="id"]');
      var id = variantInput ? variantInput.value : '';
      track('begin_checkout', {
        variant_id: id,
        offer: root.dataset.currentLabel || '',
        value: Number(root.dataset.currentPrice || 0),
        currency: root.dataset.currency || 'EUR',
        source: source || 'buybox'
      });

      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

      fetch('/cart/clear.js', { method: 'POST', headers: headers })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout refuse');
          /* Dans l'éditeur de thème, l'aperçu est une iframe qui bloque la
             navigation vers le paiement : on l'ouvre alors dans un nouvel
             onglet et on rend la main au bouton, pour qu'il reste démontrable.
             En boutique réelle, la redirection directe est conservée. */
          if (window.Shopify && window.Shopify.designMode) {
            window.open('/checkout', '_blank');
            busy = false;
            button.classList.remove('is-busy');
            return;
          }
          window.location.assign('/checkout');
        })
        .catch(function () {
          /* Repli : on laisse le formulaire natif faire le travail. */
          busy = false;
          button.classList.remove('is-busy');
          form.submit();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      go('buybox');
    });

    each(document.querySelectorAll('[data-v4-checkout]'), function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        go(el.dataset.v4Checkout || 'rappel');
      });
    });

    each(document.querySelectorAll('[data-v4-amazon]'), function (a) {
      a.addEventListener('click', function () {
        track('amazon_outbound_click', {
          variant_id: root.dataset.currentVariant || '',
          offer: root.dataset.currentLabel || '',
          value: Number(root.dataset.currentPrice || 0),
          position: a.dataset.position || 'buybox',
          page_url: window.location.href,
          destination: a.href
        });
      });
    });
  }

  /* ------------------------------------------------ 4. Barre d'achat fixe
     Règle : tant que le bouton d'ajout du hero est visible, la barre reste
     masquée. Elle apparaît quand ce bouton est sorti par le haut, et
     disparaît dès que la conclusion commerciale entre à l'écran ou qu'un
     panneau modal est ouvert.

     Le calcul se fait à partir des positions réelles plutôt que d'un
     IntersectionObserver : Horizon place le défilement sur .page-wrapper, et
     un observateur mal ancré affichait la barre dès le haut de page. */
  function initBar() {
    var bar = document.querySelector('[data-v4-bar]');
    var anchor = document.querySelector('[data-v4-buy]');
    if (!bar || !anchor) return;

    var trigger = bar.querySelector('[data-v4-bar-add]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var submit = anchor.querySelector('[data-v4-submit]');
        if (submit) submit.click();
        else anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }

    var scroller = document.querySelector('.page-wrapper') || document.scrollingElement || window;
    var closing = document.querySelector('[data-v4-closing]');
    var ticking = false;

    function modalOpen() {
      return !!document.querySelector('dialog[open], [aria-modal="true"], .drawer[open], cart-drawer[open]');
    }

    function update() {
      ticking = false;
      var submit = anchor.querySelector('[data-v4-submit]') || anchor;
      var box = submit.getBoundingClientRect();
      /* Le bouton principal est encore utilisable : rien ne doit le doubler. */
      var mainVisible = box.bottom > 8;
      var atClosing = false;
      if (closing) {
        var c = closing.getBoundingClientRect();
        atClosing = c.top < window.innerHeight * 0.85 && c.bottom > 0;
      }
      bar.classList.toggle('is-visible', !mainVisible);
      bar.classList.toggle('is-muted', atClosing || modalOpen());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    ['scroll', 'resize'].forEach(function (evt) {
      window.addEventListener(evt, onScroll, { passive: true });
    });
    if (scroller && scroller.addEventListener && scroller !== window) {
      scroller.addEventListener('scroll', onScroll, { passive: true });
    }
    document.addEventListener('shopify:cart:lines-update', onScroll);

    update();
    window.setTimeout(update, 600);
  }

  /* --------------------------------------------------- 5. Onglets bénéfices */
  function initTabs(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var tabs = root.querySelectorAll('[role="tab"]');
    var panels = root.querySelectorAll('[role="tabpanel"]');
    if (!tabs.length) return;

    function select(i, focus) {
      each(tabs, function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
      });
      each(panels, function (p, n) {
        p.classList.toggle('is-active', n === i);
        p.hidden = n !== i;
      });
    }

    each(tabs, function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var last = tabs.length - 1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); select(i === last ? 0 : i + 1, true); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); select(i === 0 ? last : i - 1, true); }
        if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        if (e.key === 'End') { e.preventDefault(); select(last, true); }
      });
    });

    select(0);
  }

  /* ------------------------------------------------- 6. Carrousels horizontaux */
  function initCarousel(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var track = root.querySelector('[data-v4-scroller]');
    var prev = root.querySelector('[data-v4-scroll-prev]');
    var next = root.querySelector('[data-v4-scroll-next]');
    if (!track) return;

    function step(dir) {
      var first = track.firstElementChild;
      var amount = first ? first.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: reduce ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ------------------------------------------------------------- 7. Avis
     Filtres par source, chargement progressif et texte complet au clic.
     Tous les avis sont dans le HTML : le filtre masque, il ne recharge rien.
     Le nombre affiché au départ dépend de la largeur, pour ne pas noyer le
     petit écran sous une grille interminable. */
  function initReviews(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-v4-review]'));
    var more = root.querySelector('[data-v4-more]');
    var chips = root.querySelectorAll('[data-v4-filter]');
    var empty = root.querySelector('[data-v4-empty]');
    var tally = root.querySelector('[data-v4-tally]');
    var wide = window.matchMedia('(min-width: 700px)').matches;
    var stepSize = parseInt(wide ? root.dataset.step || '9' : root.dataset.stepMobile || '6', 10);
    var shown = stepSize;
    var filter = 'all';

    function matches(card) {
      return filter === 'all' || (card.dataset.source || '') === filter;
    }

    function render() {
      var count = 0;
      cards.forEach(function (card) {
        if (!matches(card)) { card.hidden = true; return; }
        count += 1;
        card.hidden = count > shown;
      });
      if (more) more.hidden = count <= shown;
      if (empty) empty.hidden = count !== 0;
      if (tally) {
        tally.textContent = tally.dataset.pattern
          .replace('{visibles}', Math.min(shown, count))
          .replace('{total}', count);
        tally.hidden = count === 0;
      }
    }

    if (more) {
      more.addEventListener('click', function () {
        shown += stepSize;
        render();
        /* Le focus reste sur le bouton tant qu'il existe, sinon il repart sur
           la première carte révélée : la navigation au clavier ne se perd pas. */
        if (more.hidden) {
          var next = cards.filter(function (c) { return !c.hidden; }).pop();
          if (next) { next.setAttribute('tabindex', '-1'); next.focus(); }
        }
      });
    }

    each(chips, function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.dataset.filter || 'all';
        shown = stepSize;
        each(chips, function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        render();
      });
    });

    each(root.querySelectorAll('[data-v4-expand]'), function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-v4-review]');
        if (!card) return;
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    render();
  }

  /* -------------------------------------------- 8. Apparition au défilement */
  function revealAll() {
    each(document.querySelectorAll('.v4-in'), function (n) { n.classList.add('is-in'); });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.v4-in');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }

    /* Filet de sécurité : une panne d'observateur ne doit jamais vider la page. */
    window.setTimeout(revealAll, 1500);

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
    );

    each(nodes, function (n) { io.observe(n); });
  }

  /* ------------------------------------------------ Vidéo fondateur premium
     La couverture choisie reste affichée jusqu'au clic. Au clic, la vidéo
     Shopify démarre dans le même cadre (ou l'iframe est injectée), sans lecture
     automatique au son ni nouvel onglet. Pendant la lecture, la barre d'achat
     fixe se retire pour ne jamais masquer les contrôles ; elle revient à la
     pause, à la fin, ou quand la vidéo n'est plus à l'écran. */
  function initVideo(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var play = root.querySelector('[data-v4-video-play]');
    var video = root.querySelector('[data-v4-video-el]');
    var embed = root.getAttribute('data-v4-embed');
    var visible = true;

    function barOn() { if (visible) document.body.classList.add('v4-video-playing'); }
    function barOff() { document.body.classList.remove('v4-video-playing'); }

    function start() {
      root.classList.add('is-playing');
      if (video) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        try { video.focus({ preventScroll: true }); } catch (e) {}
      } else if (embed) {
        var frame = document.createElement('iframe');
        frame.src = embed;
        frame.title = root.getAttribute('data-v4-title') || 'Vidéo Animoco';
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        frame.loading = 'eager';
        root.appendChild(frame);
        barOn();
      }
    }

    if (play) play.addEventListener('click', start);
    if (video) {
      video.addEventListener('play', barOn);
      video.addEventListener('pause', barOff);
      video.addEventListener('ended', barOff);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (!visible) barOff();
          else if (video && !video.paused && root.classList.contains('is-playing')) barOn();
          else if (embed && root.querySelector('iframe')) barOn();
        });
      }, { threshold: 0.25 }).observe(root);
    }
  }

  function boot(scope) {
    var s = scope || document;
    each(s.querySelectorAll('[data-v4-gallery]'), initGallery);
    each(s.querySelectorAll('[data-v4-buy]'), function (n) { initOffers(n); initCheckout(n); });
    each(s.querySelectorAll('[data-v4-tabs]'), initTabs);
    each(s.querySelectorAll('[data-v4-carousel]'), initCarousel);
    each(s.querySelectorAll('[data-v4-reviews]'), initReviews);
    each(s.querySelectorAll('[data-v4-video]'), initVideo);
    initBar();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
